import CustomButton from "../CustomButton";

import { ReactComponent as Tick } from "../../static/images/tick_sign.svg";
import "./style.scss";

const ModalWarning = ({
  warningText,
  modalSubText,
  changeModal,
  modalValue,
  Image = null,
  buttonText,
  handleButton,
}) => {
  // modalValue - "modal-warning"

  return (
    <div className={`warning-container ${modalValue}`}>
      <div className="warning-content">
        <div className="warning-icon">{Image ? <Image /> : <Tick />}</div>
        <div className="warning-text">
          <h3>{warningText}</h3>
        </div>
        <div className="warning-sub-text">
          <span>{modalSubText}</span>
        </div>
        <div className="warning-button">
          <CustomButton
            variant="outlined"
            onClick={() => {
              changeModal("");

              if (handleButton) handleButton();
            }}
          >
            {buttonText}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default ModalWarning;
